import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ProductAccessService } from '../services/product-access.service';

export function requireProductAccess(productId: string, fallbackUrl = '/product-disabled'): CanActivateFn {
  return async () => {
    const productAccessService = inject(ProductAccessService);
    const router = inject(Router);

    const hasAccess = await productAccessService.checkProductAccess(productId);
    return hasAccess || router.parseUrl(fallbackUrl);
  };
}

export function requireNoProductAccess(productId: string, redirectUrl = '/dashboard'): CanActivateFn {
  return async () => {
    const productAccessService = inject(ProductAccessService);
    const router = inject(Router);

    const hasAccess = await productAccessService.checkProductAccess(productId);
    return hasAccess ? router.parseUrl(redirectUrl) : true;
  };
}
